import { FunctionComponent } from 'preact';
import { useSelector, useDispatch } from 'react-redux';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getVoltaxLogoStyleObject } from './voltaxLogo.style';
import { ToolTip } from '../../../../common/components/toolTip/toolTip';
import { TOOLTIP_TITLES } from '../../controlsPlugin.constants';
import { TOOLTIP_POSITIONS } from '../../../../common/components/toolTip/toolTip.contants';
import { Icon } from '../../../../common/components/icon/icon';
import { CONTROLS_ICON_TYPES } from '../../icon/iconMapper';
import { getVoltaxLogoId, getVoltaxLogoTooltipId } from '../../htmlElements/htmlElementsIdGetter';
import { isDesktopMode } from '../../../../common/utils/utils';
import { adsDataSelector } from '../../../../common/store/selectors/adsData.selector';
import { css } from '../../../../common/styles/styles.utils';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';
import { setUserInteraction, setShowControls } from '../../store/controlsPlugin.actions';

const ARIA_LABEL = 'Visit site';

export const VoltaxLogo: FunctionComponent = () => {
  const dispatch = useDispatch();
  const playerMode = useSelector(playerDataSelector.playerMode);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const voltaxLogoEnabled = useSelector(brandingDataSelector.showVoltaxLogo);

  const desktopMode = isDesktopMode(playerMode);
  const hideVoltaxLogo = !voltaxLogoEnabled || (isVastAd && adBreak);

  const styles = useStyles(getVoltaxLogoStyleObject, [playerSize, hideVoltaxLogo, desktopMode]);
  const { voltaxLogoStyle, voltaxLogoWrapperStyle, iconAndToolTipContainerStyle } = styles;

  const onVoltaxLogoClicked = (): void => {
    dispatch(setUserInteraction('VoltaxLogoClicked'));
  };

  const onVoltaxLogoKeyDown = (): void => {
    onVoltaxLogoClicked();
    window.open('https://www.minutemedia.com/', '_blank', 'noopener,noreferrer');
  };

  const onVoltaxLogoFocus = (): void => {
    dispatch(setShowControls(true));
  };

  const VoltaxIcon: FunctionComponent = () => (
    <a
      href="https://www.minutemedia.com/"
      target="_blank"
      rel="noopener noreferrer"
      onClick={onVoltaxLogoClicked}
      style={css(voltaxLogoWrapperStyle)}
      tabIndex={-1}
    >
      <Icon
        id={getVoltaxLogoId(playerUniqueId)}
        icon={CONTROLS_ICON_TYPES.VOLTAX_LOGO}
        style={css(voltaxLogoStyle)}
        onControlFocus={onVoltaxLogoFocus}
        onClick={onVoltaxLogoKeyDown}
        ariaLabel={ARIA_LABEL}
      />
    </a>
  );

  return (
    desktopMode
      ? (
        <div style={css(iconAndToolTipContainerStyle)}>
          <ToolTip
            id={getVoltaxLogoTooltipId(playerUniqueId)}
            content={TOOLTIP_TITLES.VOLTAX}
            position={TOOLTIP_POSITIONS.TOP}
          >
            <VoltaxIcon />
          </ToolTip>
        </div>
      )
      : (
        <VoltaxIcon />
      )
  );
};
